import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';
import IconHome from 'components/icons/IconHome';
import Chip from 'components/common/Chip';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    paddingTop: 12,
    paddingBottom: 12,
    marginRight: 8,
    marginLeft: 8,
  },
  chip: {
    backgroundColor: theme.palette.validation[500],
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconHome: {
    width: 20,
    color: theme.palette.common.white,
  },
});

const OrdersTableRowItemEditAddress = ({
  className,
  href,
  classes,
}) => (
  <div className={classNames(classes.root, className)}>
    <Link
      href={href}
      className={classes.link}
    >
      <Chip
        className={classes.chip}
        size="sm"
        color="error"
        borderColor="error"
        label={(
          <IconHome className={classes.iconHome} />
        )}
      />
    </Link>
    <Typography variant="caption">
      No Address Information
    </Typography>
  </div>
);

OrdersTableRowItemEditAddress.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    chip: PropTypes.string.isRequired,
    iconHome: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersTableRowItemEditAddress.defaultProps = {
  className: '',
};

export default withStyles(styles)(OrdersTableRowItemEditAddress);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemEditAddress.js